import { Avatar } from '@mui/material'
import { DisplayNameDetails } from 'components/core/display-name-details'
import { C1Icon } from 'components/core/icons/C1Icon'
import { greyIconAvatarSx } from 'components/core/webhooks/WebhookDisplayName'
import { AccessReviewValue } from 'lib/actions/access_review'
import { routes } from 'lib/routes'
import { ListTodo } from 'lucide-react'
import { FC } from 'react'

export type C1AccessReviewDisplayNameProps = {
    accessReview: AccessReviewValue
    readOnly?: boolean
    drawerContent?: React.ReactElement
}

export const C1AccessReviewDisplayName: FC<C1AccessReviewDisplayNameProps> = ({
    accessReview,
    readOnly = false,
    drawerContent,
}) =>
    <DisplayNameDetails
        avatar={
            <Avatar sx={greyIconAvatarSx}>
                <C1Icon icon={ListTodo} size="sm" sx={{ color: 'info.main' }} />
            </Avatar>
        }
        displayName={accessReview.displayName}
        link={readOnly ? undefined : routes.campaigns.detail(accessReview.id)}
        drawerContent={drawerContent}
        readOnly={readOnly}
        margin={false}
    />
